<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-overlay v-if="loadingCatalogos" absolute color="primary">
          <v-progress-circular indeterminate size="64" color="secondary"></v-progress-circular>
          <p class="mt-4 text-center">Cargando datos...</p>
        </v-overlay>
        <v-form ref="form" v-model="studiesForm">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="estudio.institucion"
                rounded
                filled
                dense
                background-color="transparent"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Institución o escuela <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="generacionInicio"
                maxlength="4"
                rounded
                filled
                dense
                background-color="transparent"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Año de inicio <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="generacionFin"
                maxlength="4"
                rounded
                filled
                dense
                background-color="transparent"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Año de finalización <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                background-color="transparent"
                color="secondary"
                rounded
                filled
                dense
                :items="estatusEstudios"
                item-value="id"
                item-text="title"
                v-model="estudio.fk_idCatEstatusEstudio"
                :rules="required"
              >
                <template v-slot:label>Estatus de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="transparent"
                color="secondary"
                rounded
                filled
                dense
                :items="tipoEstudios"
                item-value="id"
                item-text="title"
                v-model="estudio.fk_idCatEstudio"
                :rules="required"
              >
                <template v-slot:label>Tipo de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="transparent"
                color="secondary"
                rounded
                filled
                dense
                :items="comprobanteEstudios"
                item-value="id"
                item-text="title"
                v-model="estudio.fk_idComprobanteEstudio"
                :rules="required"
              >
                <template v-slot:label> Tipo de comprobante de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                no-resize
                rows="4"
                color="secondary"
                background-color="transparent"
                label="Observaciones (Opcional)"
                v-model="estudio.observaciones"
                rounded
                filled
                dense
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton :loading="loading" :disabled="!studiesForm || loading" @click="guardarCambios">
        Guardar cambios
      </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },

  data() {
    return {
      studiesForm: false,
      loading: false,
      loadingCatalogos: false,
      generacionInicio: '',
      generacionFin: '',
      estudio: {
        idEstudioPersonal: null,
        fk_idPersonal: null,
        institucion: '',
        generacion: '',
        observaciones: '',
        fk_idCatEstatusEstudio: null,
        fk_idCatEstudio: null,
        fk_idComprobanteEstudio: null,
      },
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('comprobanteEstudios', {
      comprobanteEstudios: 'getComprobantesEstudios',
    }),
    ...mapGetters('estatusEstudios', {
      estatusEstudios: 'getEstatusEstudios',
    }),
    ...mapGetters('estudio', {
      tipoEstudios: 'getTipoEstudios',
      selectedEstudio: 'getSelectedEstudio',
    }),
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
  },

  methods: {
    ...mapActions('estudio', ['updateEstudiosPersonal', 'fetchEstudiosByPersonal', 'fetchTipoEstudios']),
    ...mapActions('comprobanteEstudios', ['fetchComprobantesEstudios']),
    ...mapActions('estatusEstudios', ['fetchEstatusEstudios']),

    async cargarCatalogos() {
      this.loadingCatalogos = true
      try {
        // Ejecutar las peticiones en paralelo solo si no existen los datos
        const promises = []

        if (!this.comprobanteEstudios || this.comprobanteEstudios.length === 0) {
          promises.push(this.fetchComprobantesEstudios())
        }

        if (!this.estatusEstudios || this.estatusEstudios.length === 0) {
          promises.push(this.fetchEstatusEstudios())
        }

        if (!this.tipoEstudios || this.tipoEstudios.length === 0) {
          promises.push(this.fetchTipoEstudios())
        }

        // Esperar a que todas las peticiones terminen en paralelo
        await Promise.all(promises)
      } catch (error) {
        console.error('Error al cargar catálogos:', error)
      } finally {
        this.loadingCatalogos = false
      }
    },

    cargarDatosEstudio() {
      if (this.selectedEstudio) {
        this.estudio = {
          idEstudioPersonal: this.selectedEstudio.idEstudioPersonal,
          fk_idPersonal: this.selectedEstudio.fk_idPersonal,
          institucion: this.selectedEstudio.institucion,
          generacion: this.selectedEstudio.generacion,
          observaciones: this.selectedEstudio.observaciones,
          fk_idCatEstatusEstudio: this.selectedEstudio.fk_idCatEstatusEstudio,
          fk_idCatEstudio: this.selectedEstudio.fk_idCatEstudio,
          fk_idComprobanteEstudio: this.selectedEstudio.fk_idComprobanteEstudio,
        }

        if (this.estudio.generacion) {
          const [inicio, fin] = this.estudio.generacion.split('-')
          this.generacionInicio = inicio || ''
          this.generacionFin = fin || ''
        }
      }
    },

    async guardarCambios() {
      if (!this.estudio.idEstudioPersonal) {
        console.error('Error: ID del estudio no encontrado')
        return
      }

      this.loading = true
      try {
        const payload = {
          id: this.estudio.idEstudioPersonal,
          fk_idPersonal: this.estudio.fk_idPersonal,
          institucion: this.estudio.institucion,
          generacion: this.generacionInicio + '-' + this.generacionFin,
          observaciones: this.estudio.observaciones,
          fk_idCatEstatusEstudio: this.estudio.fk_idCatEstatusEstudio,
          fk_idCatEstudio: this.estudio.fk_idCatEstudio,
          fk_idComprobanteEstudio: this.estudio.fk_idComprobanteEstudio,
        }

        await this.updateEstudiosPersonal(payload)
        await this.fetchEstudiosByPersonal(this.estudio.fk_idPersonal)
        this.$emit('close')
      } catch (e) {
        console.error('Error al guardar cambios:', e)
      } finally {
        this.loading = false
      }
    },
  },

  async created() {
    this.cargarDatosEstudio()
    await this.cargarCatalogos()
  },
}
</script>

<style scoped>
/* Inputs, selects y textarea */
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
  caret-color: var(--v-secondary-base) !important;
}

::v-deep input::placeholder,
::v-deep textarea::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

/* Botón de acción */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}
</style>
